import React from 'react';

interface TableProps<T> {
  data: T[];
  columns: {
    key: keyof T | string;
    label: string;
    render?: (item: T) => React.ReactNode;
    sticky?: 'left' | 'right';
    minWidth?: string;
    maxWidth?: string; 
  }[];
}


export const GenericTable = <T extends { id?: string }>({
  data,
  columns,
}: TableProps<T>) => {
  return (
    <div className="max-w-4xl mx-auto rounded-lg shadow-lg">
      {data.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          No data found. Add an entry to get started.
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                {columns.map((column) => (
                  <th
                    key={column.key.toString()}
                    style={{
                      minWidth: column.minWidth,
                      maxWidth: column.maxWidth, // Apply maxWidth
                    }}
                    className={`px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${
                      column.sticky === 'left' ? 'sticky left-0 z-10 bg-gray-50' : ''
                    } ${
                      column.sticky === 'right' ? 'sticky right-0 z-10 bg-gray-50' : ''
                    }`}
                  >
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {data.map((item, index) => (
                <tr
                  key={item.id || index}
                  className="hover:bg-gray-50 group"
                >
                  {columns.map((column) => (
                    <td
                      key={column.key.toString()}
                      style={{
                        minWidth: column.minWidth,
                        maxWidth: column.maxWidth, // Apply maxWidth
                        overflow: column.maxWidth ? 'hidden' : undefined, // Optionally handle overflow
                        textOverflow: column.maxWidth ? 'ellipsis' : undefined, // Add ellipsis for clipped content
                        whiteSpace: column.maxWidth ? 'nowrap' : undefined, // Prevent wrapping
                      }}
                      className={`px-6 py-4 text-sm text-gray-500 ${
                        column.sticky === 'left' ? 'sticky left-0 bg-white z-10' : ''
                      } ${
                        column.sticky === 'right' ? 'sticky right-0 bg-white z-10' : ''
                      } group-hover:bg-gray-50`}
                    >
                      {column.render ? column.render(item) : (item[column.key as keyof T] as React.ReactNode)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
